<template lang="pug">
.color-picker-field-widget
  div
    filter-field-widget(:field="filter", v-on:change-color-filter-values="filterUpdated")
    div(v-for="range, rangeKey in colorAFormated.range" v-if="rangeIsNotEmpty(colorAFormated, rangeKey)")
      .range-color-header-parts
        span.range-color-header-part.title(v-text="range.label")
        span.range-color-header-part
          span(v-text="range.priceindicator")
          img.picto(v-for="picto in range.picto" :src="picto")
        span.range-color-header-part.color-summary(v-if="isThisRange(colorASelectedSummary, rangeKey)" v-text="colorASelectedSummary.label")
      div
        label.round-color-input(:title="color.label" v-for="color, colorKey in colorByRangekey(colorAFormated, rangeKey)" v-if="isVisible(colorKey, colorAFormated)" :for="`colorA_${colorKey}`")
          //- img(:src="color.imageZoomUrl")
          input(type="radio", :name="`colorA`", :id="`colorA_${colorKey}`", :disabled="color.outOfStock", :value="colorKey", v-model="colorASelected")
          .img(:class="{'selected': (colorASelected === colorKey && !color.outOfStock)}" v-bind:style="{ 'background': colorPictureStyleBackground(color.imageUrl, color.outOfStock)}")
  //- 
  //- .another-color-container
  //-   .add-more-color(v-if="isOneColorType" v-on:click="changeColorType(twoColorType)")
  //-     span.add-more-color-text(v-text="frText.abTest.prd14.variationB.fields.colorPicker.addColorPrefix")
  //-     span.add-more-color-text-alt(v-text="frText.abTest.prd14.variationB.fields.colorPicker.addColorColorBSuffix")
  //-   //- 
  //-   .remove-one-color(v-if="isTwoColorType || isThreeColorType")
  //-     .remove-one-color-text(v-text="frText.abTest.prd14.variationB.fields.colorPicker.removeColorBLeftButton" v-on:click="changeColorType(oneColorType)")
  //-     .remove-one-color-text-alt(v-text="frText.abTest.prd14.variationB.fields.colorPicker.removeColorRightButton" v-on:click="changeColorType(oneColorType)")
  //-     .remove-one-color-text-subtitle.color-picker-summary-value-error.fp-error--excl(v-html="checkColorErrors('colorisB')" v-if="checkColorErrors('colorisB')")
  //-     .remove-one-color-text-subtitle(v-text="")
  //-     //- ---
  //-     div(v-for="range, rangeKey in colorBFormated.range" v-if="rangeIsNotEmpty(colorBFormated, rangeKey)")
  //-       .range-color-header-parts
  //-         span.range-color-header-part.title(v-text="range.label")
  //-         span.range-color-header-part
  //-           span(v-text="range.priceindicator")
  //-           img.picto(v-for="picto in range.picto" :src="picto")
  //-         span.range-color-header-part.color-summary(v-if="isThisRange(colorBSelectedSummary, rangeKey)" v-text="colorBSelectedSummary.label")
  //-       div
  //-         label.round-color-input(:title="color.label" v-for="color, colorKey in colorByRangekey(colorBFormated, rangeKey)" v-if="isVisible(colorKey, colorBFormated)" :for="`colorB_${colorKey}`")
  //-           //- img(:src="color.imageZoomUrl")
  //-           input(type="radio", :name="`colorB`", :id="`colorB_${colorKey}`", :disabled="color.outOfStock", :value="colorKey", v-model="colorBSelected")
  //-           .img(:class="{'selected': (colorBSelected === colorKey)}" v-bind:style="{ 'background': colorPictureStyleBackground(color.imageZoomUrl, color.outOfStock)}")
    
  //- 
  .another-color-container(v-if="cc.config_1.product_reference !== 'PRD-14_store-californien'")
    .add-more-color(v-if="isTwoColorType" v-on:click="changeColorType(threeColorType)")
      span.add-more-color-text(v-text="frText.abTest.prd14.variationB.fields.colorPicker.addColorPrefix")
      span.add-more-color-text-alt(v-text="frText.abTest.prd14.variationB.fields.colorPicker.addColorColorCSuffix")
    //- 
    .remove-one-color(v-if="isThreeColorType")
      .remove-one-color-text(v-text="frText.abTest.prd14.variationB.fields.colorPicker.removeColorCLeftButton" v-on:click="changeColorType(twoColorType)")
      .remove-one-color-text-alt(v-text="frText.abTest.prd14.variationB.fields.colorPicker.removeColorRightButton" v-on:click="changeColorType(twoColorType)")
      .remove-one-color-text-subtitle.color-picker-summary-value-error.fp-error--excl(v-html="checkColorErrors('colorisC')" v-if="checkColorErrors('colorisC')")
      .remove-one-color-text-subtitle(v-text="")
      //- ---
      div(v-for="range, rangeKey in colorCFormated.range" v-if="rangeIsNotEmpty(colorCFormated, rangeKey)")
        .range-color-header-parts
          span.range-color-header-part.title(v-text="range.label")
          span.range-color-header-part
            span(v-text="range.priceindicator")
            img.picto(v-for="picto in range.picto" :src="picto")
          span.range-color-header-part.color-summary(v-if="isThisRange(colorCSelectedSummary, rangeKey)" v-text="colorCSelectedSummary.label")
        div
          label.round-color-input(:title="color.label" v-for="color, colorKey in colorByRangekey(colorCFormated, rangeKey)" v-if="isVisible(colorKey, colorCFormated)" :for="`colorC_${colorKey}`")
            //- img(:src="color.imageZoomUrl")
            input(type="radio", :name="'colorC'", :id="`colorC_${colorKey}`", :disabled="color.outOfStock", :value="colorKey", v-model="colorCSelected")
            .img(:class="{'selected': (colorCSelected === colorKey)}" v-bind:style="{ 'background': colorPictureStyleBackground(color.imageUrl, color.outOfStock)}")
</template>
<script>
import fr from '../../../config/translationFr'
import FilterFieldWidget from './FilterFieldWidget'
export default {
  name: 'color-picker-field-widget',
  props: {

    filter: {
      type: Object,
      default: {}
    },
    colorisA: {
      type: Object,
      default: {}
    },
    colorisB: {
      type: Object,
      default: {}
    },
    colorisC: {
      type: Object,
      default: {}
    },
    totalColorVariation: {
      type: Object,
      default: {}
    },
    cc: {
      type: Object,
      default: () => ({
        config_1: {
          prefilled_values: {
            'CH-142_type-de-store': null,
            'FIL-9_coloris': null,
            'CH-143_coloris-1': null,
            'CH-144_coloris-2': null,
            'CH-145_coloris-3': null
          }
        }
      })
    },
    uom: {
      type: String,
      default: 'cm'
    },
    fieldHasChanged: {
      type: Function,
      default: function () {}
    },
    mint: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      totalColorVariationSelected: null,
      colorASelected: null,
      colorBSelected: null,
      colorCSelected: null,
      oneColorType: 'OPT-231_store-1-couleur',
      twoColorType: 'OPT-232_store-2-couleurs',
      threeColorType: 'OPT-233_store-3-couleurs',
      colorASelectedSummary: {
        range: '',
        label: ''
      },
      colorBSelectedSummary: {
        range: '',
        label: ''
      },
      colorCSelectedSummary: {
        range: '',
        label: ''
      }
    }
  },
  created: function () {
    this.totalColorVariationSelected = this.cc.config_1.prefilled_values['CH-142_type-de-store']
    this.colorASelected = this.cc.config_1.prefilled_values['CH-143_coloris-1']
    this.colorBSelected = this.cc.config_1.prefilled_values['CH-144_coloris-2']
    this.colorCSelected = this.cc.config_1.prefilled_values['CH-145_coloris-3']
  },
  components: {
    FilterFieldWidget
  },
  computed: {
    frText: function () {
      return fr
    },
    colorAFormated: function () {
      return this.colorFormater(this.colorisA)
    },
    colorBFormated: function () {
      return this.colorFormater(this.colorisB)
    },
    colorCFormated: function () {
      return this.colorFormater(this.colorisC)
    },
    isOneColorType: function () { return this.cc.config_1.prefilled_values['CH-142_type-de-store'] === this.oneColorType },
    isTwoColorType: function () { return this.cc.config_1.prefilled_values['CH-142_type-de-store'] === this.twoColorType },
    isThreeColorType: function () { return this.cc.config_1.prefilled_values['CH-142_type-de-store'] === this.threeColorType }
  },
  methods: {
    checkColorErrors: function (colorType) {
      switch (colorType) {
        case 'colorisB':
          return (this.colorisB.validation.errors || []).join('<br/>')
        case 'colorisC':
          return (this.colorisC.validation.errors || []).join('<br/>')
      }
    },
    isThisRange: function (color, rangeKey) {
      if (color) {
        return color.range === rangeKey
      }
      return false
    },
    changeColorType: function (colorTypeKey) {
      if (this.totalColorVariationSelected === colorTypeKey) {
        this.totalColorVariationSelected = ''
      }
      this.totalColorVariationSelected = colorTypeKey
    },
    colorPictureStyleBackground: function (url, outOfStock = false) {
      const imgOutOfStock = outOfStock ? "url('https://cdn.configurateur.stores-discount.com/matiere/rupture-neutre.png') no-repeat -1px," : ''
      url = url.replace('\'', '-')
      return `${imgOutOfStock} url(${url}) no-repeat -3px -3px`
    },
    colorByRangekey: function (colorFormated, rangeKey) {
      return Object.keys(colorFormated.values).reduce((reduced, colorKey) => {
        const color = colorFormated.values[colorKey]
        if (color.range === rangeKey) {
          if (!colorFormated.validation.hidden_values.find(hiddenRangeKey => hiddenRangeKey === color.range)) {
            if (this.isVisible(colorKey, colorFormated)) {
              reduced[colorKey] = color
            }
          }
        }
        return reduced
      }, {})
    },
    sortObj: function (obj) {
      return Object.fromEntries(
        Object.entries(obj).sort(([ , a ], [ , b ]) => a.weight - b.weight)
      )
    },
    colorFormater: function (colorField) {
      Object.keys(colorField.range).forEach(rangeKey => {
        const range = colorField.range[rangeKey]
        //
        range.key = rangeKey
        switch (range.key) {
          // 127 mm Tamisant Uni
          case 'GAM-39_tamisant-uni':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-39_tamisant-uni']
            range.priceindicator = '€'
            range.picto = []
            range.weight = 1
            break
          // 127 mm Tamisant Effet Lin
          case 'GAM-42_tamisant-effet-lin':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-42_tamisant-effet-lin']
            range.priceindicator = '€'
            range.picto = []
            range.weight = 2
            break
          // 127 mm Tamisant M1 Uni
          case 'GAM-43_tamisant-m1-uni':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-43_tamisant-m1-uni']
            range.priceindicator = '€'
            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg']
            range.weight = 4
            break
          // 127 mm M1 Trévira CS
          case 'GAM-44_m1-trvira-cs':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-44_m1-trvira-cs']
            range.priceindicator = '€€'
            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg']
            range.weight = 5
            break
          // 127 mm Occultant Uni
          case 'GAM-45_occultant-uni':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-45_occultant-uni']
            range.priceindicator = '€'
            range.picto = []
            range.weight = 6
            break
          // 127 mm Occultant M1 Uni
          case 'GAM-46_occultant-m1-uni':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-46_occultant-m1-uni']
            range.priceindicator = '€€'
            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg']
            range.weight = 7
            break
          // 127 mm Voile Graphique !!!!
          case 'GAM-47_voile-graphique':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-47_voile-graphique']
            range.priceindicator = '€'
            range.picto = []
            range.weight = 8
            break
          // 127 mm Anti-chaleur
          case 'GAM-48_anti-chaleur':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-48_anti-chaleur']
            range.priceindicator = '€€'
            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-thermometre.jpg']
            range.weight = 9
            break
          // 127 mm Anti-chaleur M1
          case 'GAM-49_anti-chaleur-m1':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-49_anti-chaleur-m1']
            range.priceindicator = '€€'
            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg', 'https://cdn.stores-discount.com/images/abtest/picto-thermometre.jpg']
            range.weight = 10
            break
          // 89 mm Bois Tissé
          case 'GAM-51_bois-tiss':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-51_bois-tiss']
            range.priceindicator = '€€€'
            range.picto = []
            range.weight = 11
            break
          // 127 mm Screen Uni
          case 'GAM-52_screen-uni':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-52_screen-uni']
            range.priceindicator = '€€€'
            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg', 'https://cdn.stores-discount.com/images/abtest/picto-thermometre.jpg']
            range.weight = 52
            break
        // 89 mm Tamisant Uni
          case 'GAM-53_89-mm-tamisant-uni':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-53_89-mm-tamisant-uni']
            range.priceindicator = '€'
            range.picto = []
            range.weight = 3
            break
          // 89 mm Occultant Uni
          case 'GAM-54_89-mm-occultant-uni':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-54_89-mm-occultant-uni']
            range.priceindicator = '€'
            range.picto = []
            range.weight = 12
            break
          // New
          case 'GAM-322_occultant-anti-chaleur-127mm':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-322_occultant-anti-chaleur-127mm']
            range.priceindicator = '€€€'
            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg', 'https://cdn.stores-discount.com/images/abtest/picto-thermometre.jpg']
            range.weight = 16
            break
          case 'GAM-325_89mm-voile-haut-de-gamme':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-325_89mm-voile-haut-de-gamme']
            range.priceindicator = '€€'
            range.picto = []
            range.weight = 17
            break
          case 'GAM-324_89mm-voile-effet-lin-treviras-cs':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-324_89mm-voile-effet-lin-treviras-cs']
            range.priceindicator = '€€€'
            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg']
            range.weight = 18
            break
          case 'GAM-326_127mm-tamisant-uni-tendance':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-326_127mm-tamisant-uni-tendance']
            range.priceindicator = '€'
            range.picto = []
            range.weight = 3
            break
          case 'GAM-328_127mm-tamisant-haut-de-gamme':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-328_127mm-tamisant-haut-de-gamme']
            range.priceindicator = '€€'
            range.picto = []
            range.weight = 5
            break
          case 'GAM-329_89mm-occultant-uni-tendance':
            range.label = fr.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-329_89mm-occultant-uni-tendance']
            range.priceindicator = '€'
            range.picto = []
            range.weight = 15
            break
          default:
            range.label = range.label
            range.priceindicator = ''
            range.picto = []
            break
        }
        //
        colorField.range[rangeKey] = range
      })
      colorField.range = this.sortObj(colorField.range)
      return colorField
    },
    filterUpdated: function (chOpt) {
      this.$emit('field-changed', chOpt)
    },
    isVisible: function (colorKey, colorFormated) {
      return !colorFormated.validation.hidden_values.find(code => code === colorKey)
    },
    rangeIsNotEmpty: function (color, range) {
      return Object.keys(this.colorByRangekey(color, range)).length > 0
    }
  },
  watch: {
    cc: function (newValue, oldValue) {
      if (newValue.config_1.prefilled_values['CH-142_type-de-store'] !== oldValue.config_1.prefilled_values['CH-142_type-de-store']) {
        if (this.totalColorVariationSelected !== newValue.config_1.prefilled_values['CH-142_type-de-store']) {
          this.totalColorVariationSelected = newValue.config_1.prefilled_values['CH-142_type-de-store']
        }
      }
    },
    totalColorVariationSelected: function (newValue, oldValue) {
      this.$emit('field-changed', { [this.totalColorVariation.chKey]: { newValue: newValue } })
      if (newValue === this.oneColorType) {
        this.colorBSelected = ''
        this.colorCSelected = ''
      }
      if (newValue === this.twoColorType && oldValue === this.threeColorType) {
        this.colorCSelected = ''
      }
    },
    colorASelected: function (newValue, oldValue) {
      this.colorASelectedSummary = this.colorisA.values[newValue]
      this.colorBSelected = ''
      this.colorCSelected = ''
      this.$emit('field-changed', {
        [this.colorisA.chKey]: { newValue: newValue }
      })
    },
    colorBSelected: function (newValue, oldValue) {
      this.colorBSelectedSummary = this.colorisB.values[newValue]
      this.colorCSelected = ''
      this.$emit('field-changed', {
        [this.colorisB.chKey]: { newValue: newValue }
      })
    },
    colorCSelected: function (newValue, oldValue) {
      this.colorCSelectedSummary = this.colorisC.values[newValue]
      this.$emit('field-changed', {
        [this.colorisC.chKey]: { newValue: newValue }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ColorPickerFieldWidget.vue?4492ce12